import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/layout';
import { Article } from '../components/article';
import { ArticleProvider } from '../components/article/context';

const ArticleTemplate = ({ data }) => {
  return (
    <Layout>
      <ArticleProvider data={data}>
        <Article />
      </ArticleProvider>
    </Layout>
  );
};

export default ArticleTemplate;

export const query = graphql`
  query ArticleTemplate($id: String!, $strapiId: ID!) {
    strapiArticle(id: { eq: $id }) {
      article_name
      article_content {
        data {
          article_content
        }
      }
      article_html
      article_helpful
      article_status
      article_url
      article_seo_keywords
      article_seo_meta_description
      article_seo_title_tag
      uid
      id
      topic {
        topic_url
        topic_name
        id
      }
    }
    allStrapiArticle {
      edges {
        node {
          article_name
          article_url
          id
          uid
          topic {
            id
            topic_url
          }
          sub_topic {
            sub_topic_name
            sub_topic_order
            id
          }
        }
      }
    }
    supportcenter {
      getSupportData(input: { articleId: $strapiId }) {
        articles
      }
    }
  }
`;
